import { Option } from '@organisms/Select'
import { BaseApiResponse, CommonQueryParams, QueryType } from './common'
import { CourseCategoryServerResponse } from './courseCategory'
import { Company } from './company'
import { Filial } from './filial'
import { MintrudDictItem } from './mintrudDict'
import { CourseThemeListItemServerResponse } from './courseTheme'

export enum CourseTypes {
  TRAINING = 'training',
  PROFESSIONAL_RETRAINING = 'professionalRetraining',
  MINI = 'mini',
  LABOR_PROTECTION_TRAINING = 'laborProtectionTraining',
}

export enum CourseSubTypes {
  COURSE = 'course',
  DEMO = 'demo',
  INSTRUCTION = 'briefing',
}

export type CourseServerResponse = {
  chaptersCount: number
  listenerCourseProgressPercent: number
  courseThemesCount: number
  listenersCount: number
  courseChapters: string[]
  courseGroups: string[]
  id: number
  title: string
  subType: CourseSubTypes
  type: CourseTypes
  published: boolean
  hoursCount: number
  sortOrder: number
  descriptionLink: string | null
  courseCategory: {
    id: string
    title: string
  }
  deadlineAt: string | null
  listenerCourseGroup: ListenerCourseGroup
  safeProgram: boolean
  isClientCourse: boolean
  company?: {
    id: number
    title: string
    description: string
  } & BaseApiResponse
  ownerCompany?: Company
  companyBranch?: {
    id: number
    title: string
  } & BaseApiResponse
  finalTest?: CourseThemeListItemServerResponse
} & BaseApiResponse

export type CourseAvailabilityPairWrite = {
  company: number
  companyBranch: number | null
}

export type ListenerCourseGroup = {
  createdAt: string
  deadlineAt: string
  id: number
  listenersCount: number
  title: string
} & BaseApiResponse

export type Course = CourseServerResponse & Option & BaseApiResponse

export type CourseDetailed = {
  id: number
  title: string
  type: CourseTypes
  subType: string
  hoursCount: number
  published: boolean
  sortOrder: number
  courseCategory: CourseCategoryServerResponse
  descriptionLink: string | null
  free: boolean
  safeProgram: boolean
  company?: Company
  companyBranch?: Filial
  mintrudDict: MintrudDictItem | null
  electricalSafetyFirstGroup: boolean
  isClientCourse?: boolean
  ownerCompany?: Company
  finalTest?: CourseThemeListItemServerResponse
} & BaseApiResponse

export type CourseQueryParams = {
  courseCategory?: QueryType
  forListener?: QueryType
  forCurator?: QueryType
  type?: QueryType
  subType?: QueryType
  published?: boolean
} & CommonQueryParams

export type CommonCourseBody = {
  title: string
  type: string
  subType: string | undefined
  hoursCount: number
  published: boolean
  sortOrder?: number
  courseCategory: string
  descriptionLink: string | undefined
  free: boolean
  safeProgram: boolean
  company: string | null
  companyBranch: string | null
  mintrudDict: string | null
  courseAvailabilities?: CourseAvailabilityPairWrite[]
  electricalSafetyFirstGroup: boolean
}

export type CreateCourseBody = CommonCourseBody
export type UpdateCourseBody = CommonCourseBody & {
  id: number
}

export type PatchCourseFinalTestBody = {
  id: number
  finalTest: string | null
}

export type UploadFinalTestXlsBody = {
  id: number
  file: string
  passPercentage: number
  questionsCount: number
  hoursTime: number
}
